
export default {
  props: {
    member: { type: Object, required: true },
  },
}
